import React, { useRef, useState, useEffect } from 'react';
import { MapSimulation } from './mapSimulation';
import MapStage from './MapStage';
import MapUI from './MapUI';

function Map({ app }) {
  const simulation = useRef(null);
  const [mapVersion, setMapVersion] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);

  if (!simulation.current) {
    simulation.current = new MapSimulation();
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey(k => k + 1);
    }, 10);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-full">
      <div className="absolute inset-0">
        <MapStage 
          key={mapVersion} 
          map={simulation.current} 
          refreshKey={refreshKey}
        />
      </div>
      <div className="absolute inset-0 pointer-events-none">
        <div className="pointer-events-auto">
          <MapUI 
            key={mapVersion} 
            map={simulation.current} 
            app={app}
            onStartGame={(level) => app.goToGame(level)}
            refreshKey={refreshKey}
          />
        </div>
      </div>
    </div>
  );
}

export default Map;
